import {
  DisplayTextRendererInterface,
} from '@magieno/angular-advanced-forms';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoggingService } from '@magieno/angular-core';
import { MagienoObservabilityManager } from '../managers/magieno-observability.manager';

@Injectable()
export class MagienoAdvancedFormDisplayTextRenderer implements DisplayTextRendererInterface {
  constructor(
    private readonly translateService: TranslateService,
    private readonly loggingService: LoggingService,
    private readonly observabilityManager: MagienoObservabilityManager,
  ) {
  }

  async render(displayableText: any): Promise<string> {
    if (!displayableText) {
      return '';
    }

    const locale = this.translateService.currentLang ?? 'fr';

    if (displayableText == "boolean.no") {
      return 'Non';
    } else if (displayableText == "boolean.yes") {
      return 'Oui';
    }

    if (typeof displayableText === 'string') {
      return displayableText;
    }

    if (displayableText[locale] === undefined) {
      this.loggingService.error('Could not find translation for locale', {displayableText, locale});
      await this.observabilityManager.sendAlert('WARNING', 'Could not find translation for locale.', {
        locale,
        displayableText,
      });
      return displayableText['fr'] ?? Object.values(displayableText)[0] ?? '';
    }

    return displayableText[locale] as string;
  }

}